import { useEffect, useRef } from 'react';

const SEQ = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];

/** Fires onTrigger once per mount when the Konami code is typed. */
export function useKonami(onTrigger: () => void) {
  const pos = useRef(0);
  const fired = useRef(false);
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (fired.current) return;
      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      pos.current = key === SEQ[pos.current] ? pos.current + 1 : (key === SEQ[0] ? 1 : 0);
      if (pos.current === SEQ.length) { fired.current = true; onTrigger(); }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onTrigger]);
}
